/* Skinko: agregar al carrito directo desde "También podría interesarte" (sin salir de la página).
   Mantiene el carrusel en la misma posición de pantalla después de cada agregado. */
(function () {
  if (window.__skinkoQuickAdd) return;
  window.__skinkoQuickAdd = true;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  let busy = false;

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-skinko-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (busy || btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
    busy = true;
    btn.classList.add('is-loading');
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.skinkoAdd), quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      });
      const data = await res.json();
      if (!res.ok) throw data;
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      if (window.SkinkoCartFX) window.SkinkoCartFX.celebrate(btn, { label: false, sparks: 10 });
      await new Promise((r) => setTimeout(r, 380));

      // Guardar la posición del carrusel en pantalla antes de recargar el carrito
      const oldCross = document.querySelector('#CartDrawer .wt-cart__cross-sell');
      const anchorTop = oldCross ? oldCross.getBoundingClientRect().top : null;

      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data, false);
      }

      // Restaurar: dejar el carrusel en el mismo lugar para seguir agregando
      requestAnimationFrame(() => {
        const body = document.querySelector('#CartDrawer .wt-cart__drawer__body');
        const newCross = document.querySelector('#CartDrawer .wt-cart__cross-sell');
        if (body && newCross && anchorTop !== null) {
          body.scrollTop += newCross.getBoundingClientRect().top - anchorTop;
        } else if (body && !newCross) {
          body.scrollTop = body.scrollHeight;
        }
      });

      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'skinko-quick-add' });
      }
    } catch (err) {
      btn.classList.remove('is-loading');
      btn.classList.add('is-error');
      btn.setAttribute('title', (err && (err.description || err.message)) || 'No se pudo agregar');
      setTimeout(() => btn.classList.remove('is-error'), 1800);
    } finally {
      busy = false;
    }
  }, true);
})();
